import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../irtiza-dynamic-input/irtiza-dynamic-main-inputs';

const ProductInfoAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
  
    ProductID:{name: 'ProductID',   value: props.ProductID || '' ,enabled:false},

    ProductType:{
      name:{id:'ProductTypeID',value:'ProductType'},
      caption: 'Select Product Type',
      value: {id: props.ProductTypeID || undefined ,value:props.ProductType || ''},
      dataSource: {type:'Route',route:'ProductTypeInfo'},
        },

    ProductWidth:{name: 'ProductWidth',   value: props.ProductWidth || 0 , decimal : 0 },

    ProductLength:{name: 'ProductLength',   value: props.ProductLength || 0 , decimal : 0 },
    
    ProductName:{name: 'ProductName',   value: props.ProductName || '' },

    Unit:{
      name:{id:'UnitID',value:'Unit'},
      caption: 'Select Unit',
      value: {id: props.UnitID || undefined ,value:props.Unit || ''},
      dataSource: {type:'Route',route:'UnitInfo'},
        },
    

        });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.ProductID, setInputProps },ColumnSize:0},
    {Input: DropdownComponent,Props: {...inputProps.ProductType, setInputProps },ColumnSize:6},
    {Input: NumberComponent,Props: {...inputProps.ProductWidth,setInputProps },ColumnSize:6},
    {Input: NumberComponent,Props: {...inputProps.ProductLength,setInputProps },ColumnSize:6},
    {Input: TextComponent,Props: {...inputProps.ProductName,setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.Unit, setInputProps },ColumnSize:6},
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Product ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default ProductInfoAdd;
